import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import qs from "qs";
import Dots from "react-activity/lib/Dots";
import SearchResults from "./common/searchResults";
import { getSearchResults } from "../services/searchService";
import { getCurrentUser } from "../services/authService";

class AircraftResults extends Component {
  state = {
    data: {
      aircraft_name: "",
      year_of_manufacture: 0,
      country_of_manufacturer: "",
      manufacturer_id: 0,
      primary_group_id: 0,
      media_id: 0,
      scale_id: 0,
      kit_mold: "",
      kit_no: "",
      currentPage: 1,
      pageSize: 10,
    },
    aircrafts: [],
    itemsCount: 0,
    keyColumn: "aircraft_id",
    loaded: true,
  };

  columns = [
    {
      path: "aircraft_name",
      label: "Aircraft",
      icon: "plane",
      content: (result) => (
        <Button
          variant="link"
          onClick={() => this.handleShowDetail(result.aircraft_id)}
        >
          {result.aircraft_name}
        </Button>
      ),
    },
    {
      path: "year_of_manufacture",
      label: "Year of Manufacture",
      icon: "calendar-alt",
    },
    {
      path: "country_of_manufacturer",
      label: "Country of Manufacturer",
      icon: "flag-usa",
    },
  ];

  deleteColumn = {
    key: "delete",
    content: (result) => (
      <button
        onClick={() => this.handleDelete(result)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  constructor() {
    super();
    const user = getCurrentUser();
    if (user && user.isAdmin) this.columns.push(this.deleteColumn);
  }

  async componentDidMount() {
    this.setState({ loaded: false });

    const searchData = this.getlocalStorage();
    await this.loadResults(searchData);
  }

  async loadResults(data) {
    const { aircrafts, itemsCount } = await this.getPagedData(data);

    this.setState({ aircrafts, itemsCount, data, loaded: true });
  }

  getPagedData = async (data) => {
    const queryString = this.getQueryString(data);
    const searchResults = await getSearchResults(queryString);

    const aircrafts = searchResults.aircrafts;
    const itemsCount = searchResults.totalCount;

    return { data, aircrafts, itemsCount };
  };

  getQueryString(data) {
    const criteriaString = qs.stringify(data);

    return criteriaString;
  }

  getlocalStorage() {
    const searchData = {};

    searchData.aircraft_name = localStorage.getItem("a_aircraft_name");
    searchData.manufacturer_id = localStorage.getItem("a_manufacturer_id");
    searchData.media_id = localStorage.getItem("a_media_id");
    searchData.scale_id = localStorage.getItem("a_scale_id");
    searchData.country_of_manufacturer = localStorage.getItem(
      "a_country_of_manufacturer"
    );
    searchData.primary_group_id = localStorage.getItem("a_primary_group_id");
    searchData.year_of_manufacture = localStorage.getItem(
      "a_year_of_manufacture"
    );
    searchData.kit_mold = localStorage.getItem("a_kit_mold");
    searchData.kit_no = localStorage.getItem("a_kit_no");
    searchData.currentPage = parseInt(localStorage.getItem("a_currentPage"));
    searchData.pageSize = parseInt(localStorage.getItem("a_pageSize"));

    return searchData;
  }

  handlePageChange = async (page) => {
    const data = this.state.data;
    data.currentPage = page;

    const { aircrafts, itemsCount } = await this.getPagedData(data);

    this.setState({ aircrafts, itemsCount, data });
  };

  handleRefineSearch = () => {
    localStorage.setItem("a_currentPage", 1);
    this.props.history.push("/search/aircraft");
  };

  handleShowDetail = (aircraft_id) => {
    localStorage.setItem("a_currentPage", this.state.data.currentPage);
    this.props.history.push(`/aircraft/details/${aircraft_id}`);
  };

  render() {
    const { data, aircrafts, itemsCount, keyColumn, loaded } = this.state;

    let component;
    if (loaded === false)
      component = (
        <div className="dots_loader">
          <Dots size={26} />
        </div>
      );
    else
      component = (
        <SearchResults
          data={data}
          results={aircrafts}
          columns={this.columns}
          keyColumn={keyColumn}
          itemsCount={itemsCount}
          usePageNumbers={false}
          doPageChange={this.handlePageChange}
          onRefineSearch={this.handleRefineSearch}
          onShowDetail={this.handleShowDetail}
        />
      );

    return component;
  }
}

export default AircraftResults;
